const pl = {
  home: {
    biometric_label: "BIOMETRYCZNA WERYFIKACJA TOŻSAMOŚCI",
    title: "Odwrotne wyszukiwanie twarzy z łatwością",
    description:
      "Prześlij portret w wysokiej rozdzielczości, aby porównać go z globalnymi cyfrowymi archiwami za pomocą zaawansowanego dopasowywania neuronowego.",
    drag_drop: "Przeciągnij i upuść swoje zdjęcie",
    file_formats: "Obsługuje RAW, JPEG lub PNG (maks. 15MB)",
    select_file: "WYBIERZ PLIK Z SYSTEMU",
    initiate_scan: "Rozpocznij Skan Kryminalistyczny",
    upload_hint: "PRZEŚLIJ OBRAZ ABY KONTYNUOWAĆ",
    uploading: "Przesyłanie",
    searching: "Skanowanie",
    result_title: "Wyniki",
    drop_here: "Upuść obraz tutaj...",
    billion_faces: "Porównaj z ponad 1 miliardem twarzy w internecie",
    login_to_search: "Zaloguj się aby szukać",
    login_required:
      "Zaloguj się lub utwórz konto, aby korzystać z tej aplikacji",
    not_enough_tokens: "Niewystarczająca liczba tokenów",
    please_wait: "Proszę czekać kilka minut",
    leave_confirmation: "Trwa proces. Czy na pewno chcesz wyjść?",
  },
  sources: {
    section_title: "Przeszukiwane Źródła",
    social_media: {
      name: "Media Społecznościowe",
      description:
        "Weryfikacja w głównych sieciach społecznościowych i publicznych profilach.",
    },
    web: {
      name: "Web",
      description:
        "Przeszukuje otwarty internet pod kątem publicznie dostępnych danych twarzy.",
    },
    scammers: {
      name: "Oszuści",
      description: "Dopasowuje z bazami danych znanych oszustów i fraudów.",
    },
    sexual_offenders: {
      name: "Przestępcy Seksualni",
      description:
        "Weryfikacja z publicznymi rejestrami zarejestrowanych przestępców.",
    },
    videos: {
      name: "Wideo",
      description:
        "Ekstrahuje i porównuje twarze z publicznych platform wideo.",
    },
    police_photos: {
      name: "Zdjęcia Policyjne",
      description:
        "Porównuje z publicznie dostępnymi bazami danych policyjnych.",
    },
    news_and_blogs: {
      name: "Wiadomości i Blogi",
      description: "Przeszukuje archiwa wiadomości, treści redakcyjne i blogi.",
    },
  },
  header: {
    scan: "SKAN",
    history: "HISTORIA",
    pricing: "CENNIK",
    account: "KONTO",
    logout: "WYLOGUJ",
    app_name: "Digital Forensicist",
  },
  footer: {
    copyright:
      "© 2024 Digital Forensicist. Wszelkie prawa zastrzeżone. Precyzyjna Weryfikacja Tożsamości.",
    privacy: "Polityka Prywatności",
    terms: "Warunki Usługi",
    docs: "Dokumentacja",
    support: "Wsparcie",
  },
  common: {
    loading: "Ładowanie...",
    error: "Błąd",
    cancel: "Anuluj",
    back: "Wstecz",
  },
  errors: {
    upload_failed: "Przesyłanie nie powiodło się. Spróbuj ponownie.",
    not_enough_tokens:
      "Nie masz wystarczającej liczby tokenów, aby przeprowadzić to wyszukiwanie.",
  },
  login: {
    disclaimer:
      "Potrzebujesz konta, aby korzystać z tej aplikacji. Nie wysyłamy spamu ani nie udostępniamy Twojego e-maila. Zalecamy logowanie przez Apple dla zachowania prywatności.",
  },
  results: {
    input_source: "ŹRÓDŁO WEJŚCIOWE",
    match_thumbnail: "Miniatura dopasowania",
    extraction_id: "ID EKSTRAKCJI",
    scan_analysis: "Analiza skanowania",
    scan_description:
      "Biometryczne wyszukiwanie wsteczne zakończone. Znaleziono %{count} potencjalnych dopasowań w rejestrach publicznych i indeksach społecznościowych.",
    col_identity_map: "MAPA TOŻSAMOŚCI",
    col_verification_path: "ŚCIEŻKA WERYFIKACJI",
    col_bio_match_score: "WYNIK BIO",
    col_action: "AKCJA",
    export_pdf: "Eksportuj PDF",
    exporting: "Generowanie...",
    verified: "ZWERYFIKOWANO",
    details: "SZCZEGÓŁY",
    details_tooltip: "Uruchom precyzyjne porównanie twarzy",
    details_loading: "Porównuję...",
    copied: "Skopiowano!",
    copy_url: "Kopiuj URL",
    displaying: "Wyświetlanie %{count} z %{total} wykryć",
  },
};

export default pl;
